/* 6FT Club wishlist. No app: saved product handles live in this browser's
   localStorage, newest first.

   - Any button[data-wishlist-toggle][data-product-handle] saves / unsaves.
   - [data-wishlist-count] shows the number of saved products (hidden at 0).
   - [data-wishlist-page] is the /pages/wishlist grid: it renders each saved
     product with the real product card (/products/<handle>?view=card).
   Tabs stay in sync through the storage event. Loaded once from the layout. */
(function () {
  if (window.SixFtWishlist) return;

  var STORAGE_KEY = '6ft-wishlist';
  var MAX_ITEMS = 60;
  var LABEL_ADD = 'Save to wishlist';
  var LABEL_REMOVE = 'Remove from wishlist';

  function read() {
    try {
      var raw = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(raw) ? raw.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (err) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, MAX_ITEMS)));
      return true;
    } catch (err) {
      return false;
    }
  }

  function has(handle) { return read().indexOf(handle) !== -1; }

  function toggle(handle) {
    var list = read();
    var saved = list.indexOf(handle) === -1;
    var next = saved
      ? [handle].concat(list)
      : list.filter(function (h) { return h !== handle; });
    if (!write(next)) return null;
    sync();
    document.dispatchEvent(new CustomEvent('sixft:wishlist', { detail: { handle: handle, saved: saved, count: next.length } }));
    return saved;
  }

  function sync() {
    var list = read();
    Array.prototype.forEach.call(document.querySelectorAll('[data-wishlist-toggle]'), function (btn) {
      var on = list.indexOf(btn.dataset.productHandle) !== -1;
      btn.classList.toggle('is-saved', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? LABEL_REMOVE : LABEL_ADD);
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-wishlist-count]'), function (el) {
      el.textContent = list.length;
      el.hidden = list.length === 0;
    });
  }

  /* ---------------- /pages/wishlist ---------------- */
  function fetchCard(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '?view=card', { credentials: 'same-origin' })
      .then(function (res) {
        if (res.status === 404) return { handle: handle, gone: true };
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text().then(function (html) { return { handle: handle, html: html }; });
      })
      .catch(function () { return { handle: handle, failed: true }; });
  }

  function renderPage(root) {
    var grid = root.querySelector('[data-wishlist-grid]');
    var empty = root.querySelector('[data-wishlist-empty]');
    var error = root.querySelector('[data-wishlist-error]');
    var list = read();

    root.classList.remove('is-loading');
    error.hidden = true;
    if (!list.length) {
      grid.innerHTML = '';
      grid.hidden = true;
      empty.hidden = false;
      return;
    }

    root.classList.add('is-loading');
    Promise.all(list.map(fetchCard)).then(function (results) {
      root.classList.remove('is-loading');
      // Products deleted or unpublished since they were saved drop out quietly.
      var gone = results.filter(function (r) { return r.gone; }).map(function (r) { return r.handle; });
      if (gone.length) {
        write(read().filter(function (h) { return gone.indexOf(h) === -1; }));
        sync();
      }
      var cards = results.filter(function (r) { return r.html; });
      error.hidden = !results.some(function (r) { return r.failed; });
      grid.innerHTML = cards.map(function (r) { return r.html; }).join('');
      grid.hidden = cards.length === 0;
      empty.hidden = cards.length !== 0 || !error.hidden;
      sync();
    });
  }

  function initPage() {
    var root = document.querySelector('[data-wishlist-page]');
    if (!root) return;
    renderPage(root);
    // Unsaving on this page removes the card straight away.
    document.addEventListener('sixft:wishlist', function (e) {
      if (e.detail.saved) return;
      var btn = root.querySelector('[data-wishlist-toggle][data-product-handle="' + CSS.escape(e.detail.handle) + '"]');
      var card = btn && btn.closest('[data-product-card]');
      if (card) card.remove();
      if (!root.querySelector('[data-product-card]')) {
        root.querySelector('[data-wishlist-grid]').hidden = true;
        root.querySelector('[data-wishlist-empty]').hidden = false;
      }
    });
    window.addEventListener('storage', function (e) { if (e.key === STORAGE_KEY) renderPage(root); });
  }

  // Capture phase: the PDP gallery stops propagation on its circle buttons.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-wishlist-toggle][data-product-handle]');
    if (!btn) return;
    e.preventDefault();
    var saved = toggle(btn.dataset.productHandle);
    if (saved === null) {
      btn.setAttribute('aria-label', 'Wishlist unavailable in this browser');
      return;
    }
    btn.classList.remove('is-popping');
    void btn.offsetWidth;
    if (saved) btn.classList.add('is-popping');
  }, true);

  window.addEventListener('storage', function (e) { if (e.key === STORAGE_KEY) sync(); });

  window.SixFtWishlist = { read: read, has: has, toggle: toggle, sync: sync };

  function init() { sync(); initPage(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
